var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-block__player-topbar"},[_c('w-logo',{attrs:{"size":"18"}}),_vm._v(" "),_c('div',{staticClass:"pl-1"},[_vm._v("Player "+_vm._s(_vm.$metadatas.appName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }